import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import Button from '@/ui-kit/components/Button/Button';

const BankAccountUpdateInProgress = ({ closeModal, confirmAction = closeModal }: ModalProps) => {
  const { t } = useTranslation(['Modal', 'Button']);

  return (
    <Modal title={t('BankAccountUpdateInProgress.title')}>
      <p>{t('BankAccountUpdateInProgress.info')}</p>
      <ModalActions>
        <Button onClick={confirmAction}>{t('Button:clear')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default BankAccountUpdateInProgress;
